import { createSlice } from '@reduxjs/toolkit';
import { fetchInvitedPlayers, fetchQrCode } from './invite.thunk';
import type { InvitedPlayer, QrResponse } from '../api/invite.types';

interface InviteState {
  qrData: QrResponse | null;
  invitedPlayers: InvitedPlayer[];
  totalIncome: number;
  loading: boolean;
  error: string | null;
}

const initialState: InviteState = {
  qrData: null,
  invitedPlayers: [],
  totalIncome: 0,
  loading: false,
  error: null,
};
const inviteSlice = createSlice({
  name: 'invite',
  initialState,
  reducers: {
    clearQrData: (state) => {
      state.qrData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQrCode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQrCode.fulfilled, (state, action) => {
        state.loading = false;
        state.qrData = {
          qrCodeUrl: action.payload.qrCodeUrl,
          directUrl: action.payload.directUrl,
          botName: action.payload.botName,
        };
      })
      .addCase(fetchQrCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchInvitedPlayers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvitedPlayers.fulfilled, (state, action) => {
        state.loading = false;
        state.invitedPlayers = action.payload.players;
        state.totalIncome = action.payload.incomeBonus;
      })
      .addCase(fetchInvitedPlayers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearQrData } = inviteSlice.actions;
export default inviteSlice.reducer;
